import React from 'react';
import PropTypes from 'prop-types';
import { getTranslation } from './Text';
import { css, StyleSheet } from 'aphrodite/no-important';
import { DOVE_GRAY, LOCHMARA, TRANSPARENT, ALTO } from '../styles';
import Panel from './Panel';
import Button from './Button';

const s = StyleSheet.create({
  root: {
    border: `1px solid ${ALTO}`,
    borderRadius: 2,
  },
  title: {
    fontSize: 14,
    // ...FONTS.BOLD,
    marginRight: 'auto',
  },
  plus: {
    width: 15,
    height: 15,
    marginRight: 5,
    color: LOCHMARA,
  },
  arrange: {
    width: 15,
    height: 15,
  },
  disabled: {
    color: DOVE_GRAY,
    backgroundColor: TRANSPARENT,
  },
  arrangeDisabled: {
    opacity: 0.2,
  },
  delete: {
    marginLeft: 5,
  },
});

const Participant = ({ name, id, onClick }) => (
  <Panel __className={[!id && s.disabled, s.root]}>
    <p
      children={name || getTranslation('app.default.participant.name')}
      className={css(s.title)}
    />
    <Button
      messageId={id ? 'app.edit' : 'app.add'}
      onClick={() => onClick(id)}
    />
  </Panel>
);

Participant.propTypes = {
  name: PropTypes.string,
  onClick: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Participant;
